import { useTranslation } from "react-i18next";
import styles from "./product-card.module.css";
import { CardProductProps } from "./type";
import {
  AppLink,
  useAppNavigate,
  PartnerCountry,
  Product,
  resizeImage,
  formatCurrency } from
"@commons-monorepo/index";
import { UiButton } from "@ui-monorepo/index";
import { useMemo } from "react";

const ProductCard = ({
  product,
  partnerCountry,
  dbProducts,
  partnerId,
  offerId,
  isPartnerPrime,
  skin
}: CardProductProps) => {
  const { t } = useTranslation();
  const navigate = useAppNavigate();

  const urlPromo = `/catalogo/${partnerId}`;

  const hasProductDiscount = (): boolean => {
    return !!product.priceWithDiscount && product.priceWithDiscount >= 0;
  };

  const hasWholesale = useMemo((): boolean => {
    return (
      product.wholesale !== undefined &&
      product.wholesale?.configurations?.length > 0);

  }, [product]);

  const cleanCategories = () => {};

  const hasProductInTheCart = (product_: Product): boolean => {
    return !!dbProducts.find((p) => p.id === product_.id);
  };

  const productUrl = !!offerId ?
  `${urlPromo}/oferta/${offerId}/producto/${
  product.friendlyUrl || product.id
  }` :
  `${urlPromo}/producto/${product.friendlyUrl || product.id}`;

  const goToProduct = () => {
    navigate(productUrl);
  };

  return product ?
  <div
    role='product'
    className={`${styles.productCard} ${
    skin ? styles[`productCard__${skin}`] : ""
    }`}>

      <div className={`${styles.tags}`}>
        {!!product.highlight &&
      <div className={`${styles.highlight}`}>
            <span className='icon-star-fill' />
          </div>}

        {hasWholesale &&
      <div className={`${styles.wholesale}`}>
            <span className='icon-light-package' />
          </div>}

      </div>
      <div className={`${styles.imageProduct__container}`}>
        <AppLink
        onClick={cleanCategories}
        to={productUrl}
        data-testid='product-card-link-detail'
        className={`${styles.linkImg}`}>

          {product?.images &&
        <img
          src={resizeImage(
            product?.images[0],
            0,
            0,
            isPartnerPrime ? 45 : 25
          )}
          alt='Preview'
          className={`${styles.img}`}
          data-testid='product-card-img'
          loading='lazy' />}


          {hasProductDiscount() &&
        <div
          className={`${styles.discount} ${
          hasProductInTheCart(product) && !product.toppings?.length ?
          styles.discount__isCart :
          ""
          }`}>

              <p
            className={`${styles.discountText}`}
            role='product-card-discount'>

                {product.percentageDiscount}%
              </p>
            </div>}

        </AppLink>
      </div>
      <div
      className={`${styles.details}`}
      data-testid='product-card-details'
      onClick={goToProduct}>

        <div className={`${styles.detailsBox}`}>
          <AppLink
          className={`${styles.link}`}
          onClick={cleanCategories}
          to={productUrl}>

            <div
            className={`${styles.containerName}`}
            onClick={cleanCategories}>

              <div className={`${styles.name}`} role='product-card-name'>
                {product?.name?.length > 64 ?
              `${product.name.slice(0, 64)}...` :
              product?.name}
              </div>
            </div>
            <div
            className={`${styles.prices}`}
            data-testid='product-card-prices'>

              {product.price > 0 &&
            <div className={`${styles.contentPrices}`}>
                  {hasProductDiscount() &&
              <div
                className={`${styles.priceWithoutDiscount}`}
                role='product-card-price-without-discount'>

                      {formatCurrency(
                  product.price, (
                  partnerCountry as PartnerCountry)
                )}
                    </div>}

                  <div className={`${styles.boxPrices}`}>
                    {hasProductDiscount() &&
                <span
                  className={`${styles.iconPercentage} icon-percentage-fill-stroke`}>
                </span>}

                    <div
                  className={`${styles.mainPrice}`}
                  role='product-card-price'>

                      <div
                    className={`${styles.productPriceStyled} ${styles.price}`}>

                        {formatCurrency(
                      product.priceWithDiscount || product.price || 0, (
                      partnerCountry as PartnerCountry)
                    )}
                      </div>
                    </div>
                  </div>
                </div>}

              <UiButton
              isFilled
              hasPersonalization
              onClick={goToProduct}
              className={`${styles.btnDetails}`}>

                <p className={`${styles.cardBtn__text}`}>
                  {t("product.see_details")}
                </p>
              </UiButton>
            </div>
          </AppLink>
        </div>
      </div>
    </div> :
  null;
};

export default ProductCard;